import { SystemUsageData } from "../../../../types"
import { numberToUSD } from "../../../utils"
import AddonsBreakdown from "./addons-breakdown"
import EmailBreakdown from "./email-breakdown"
import LeadsBreakdown from "./leads-breakdown"
import SMSBreakdown from "./sms-breakdown"

interface Props {
  usage: SystemUsageData
}

const Body = ({ usage }: Props) => {
  return (
    <div className="border-t-2 border-black mt-4 pt-6">
      <div>
        <strong>Subscription Level ({usage?.level}):</strong>{" "}
        {numberToUSD(usage?.breakdown?.cost.breakdown.base)}
      </div>
      {/* Leads Breakdown */}
      <LeadsBreakdown usage={usage} />
      {/* SMS Breakdown */}
      <SMSBreakdown usage={usage} />
      {/* Emails Breakdown */}
      <EmailBreakdown usage={usage} />
      {/* Addons Breakdown */}
      <AddonsBreakdown usage={usage} />
    </div>
  )
}

export default Body
